import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { touchStart, touchEnd, handleSwipeCtrl, staticPath } from '../../utils/common';
import { onChange } from '../../common/actions';

class CvvHelper extends Component {
  constructor(props) {
    super(props);
    this.swipeDist = 0;
    this.threshold = 10; // required min distance traveled to be considered swipe
    this.startX = 0;
    this.startY = 0;
    this.state = {
      currentSlide: 0,
      activeInd: 0,
      initialAnimation: false
    };
    this.helpText = [
      {
        textSrc: 'A three-digit code on the back panel of your card',
        imgSrc: `${staticPath()}/assets/images/cvv_help.png`
      },
      {
        textSrc: 'A four-digit code on the front panel of your card',
        imgSrc: `${staticPath()}/assets/images/amex_cvv_help.png`
      }
    ];
  }

  detectTouchStart(e) {
    const coord = touchStart(e);
    this.startX = coord.startX;
    this.startY = coord.startY;
  }

  detectTouchEnd(e, index) {
    const isrightswipe = touchEnd(e, this.startX, this.threshold);
    this.handleswipe(isrightswipe, index);
    e.preventDefault();
  }

  detectTouchMove(e) {
    e.preventDefault();
  }

  handleswipe(isrightswipe, index) {
    const res = handleSwipeCtrl(isrightswipe, index, this.helpText);
    this.setState({
      activeInd: res.actvInd,
      okBtn: res.okBtnVal,
      initialAnimation: true
    });
  }

  updateSlide(index) {
    this.setState({
      activeInd: index,
      initialAnimation: true
    });
  }

  closeOverlayWrap = () => {
    this.props.onHelperOverlayToggle('');
  };

  render({}, { activeInd, initialAnimation }) {
    const dot = `ptm-dot`;
    const dotAct = `ptm-dot ptm-btn-active`;
    const slideAct = `slide ptm-hidden`;
    const slide = `slide`;
    return (
      <div className={`ptm-cvvHelper`}>
        <div className={`ptm-close-wrap ptm-pos-a ptm-closeIcon`} onClick={this.closeOverlayWrap}>
          <span className={`ptm-cross ptm-pos-r`} />
        </div>
        <h3 className={`ptm-cvv-heading ptm-body-color`}>What is CVV </h3>
        <div className={`ptm-sliderWrap paytm-txt-center`}>
          <ul className={`ptm-upiWorkSlides`}>
            {this.helpText &&
              this.helpText.length > 0 &&
              this.helpText.map((data, index) => {
                return (
                  <li
                    onTouchStart={e => this.detectTouchStart(e)}
                    onTouchMove={e => {
                      this.detectTouchMove(e);
                    }}
                    onTouchEnd={e => this.detectTouchEnd(e, index)}
                    className={`${index === activeInd ? slide : slideAct} ${
                      index
                        ? 'ptm-animated ptmslideInRight faster'
                        : initialAnimation
                        ? 'ptm-animated ptmslideInLeft faster'
                        : ''
                    }`}
                  >
                    <p className={`ptm-cvv-para ptm-body-color`}>{data.textSrc}</p>
                    <img src={data.imgSrc} alt="" className={`ptm-margin0 ptm-image`} />
                  </li>
                );
              })}
          </ul>
        </div>
        <div className={`ptm-btn-slider`}>
          {this.helpText &&
            this.helpText.length > 0 &&
            this.helpText.map((data, index) => {
              return (
                <span
                  className={index === activeInd ? dotAct : dot}
                  onclick={() => this.updateSlide(index)}
                />
              );
            })}
        </div>
      </div>
    );
  }
}

export default connect(
  '',
  onChange
)(CvvHelper);



// WEBPACK FOOTER //
// ./components/CvvHelper/index.js